import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';
import { debounce } from 'lodash';
import CohortAxisDropdownItems from './CohortAxisDropdownItems';

const CohortAxisDropdown = ({
  value,
  axis,
  disabled,
  fields,
  onChange,
  placeholder = 'cohorts.visualisation.field.select',
}) => {
  const intl = useIntl();
  const [filterText, setFilterText] = useState('');
  const [open, setOpen] = useState(undefined);

  const field = fields.find((f) => f.name === value);
  const text = field ? field.label : intl.formatMessage({ id: placeholder });
  const resetOpen = useMemo(() => debounce(setOpen, 100), []);

  const handleScroll = (name, label) => {
    setFilterText('');
    setOpen(false);
    onChange(name, label);
    resetOpen();
  };

  return (
    <Dropdown
      item
      className={`aridhia-cohort-${axis}-dropdown`}
      disabled={disabled}
      text={text}
      search
      open={open}
      searchQuery={filterText}
      onSearchChange={
        (e, { searchQuery }) => { setFilterText(searchQuery); }
      }
    >
      <Dropdown.Menu>
        <Dropdown.Header content={intl.formatMessage({ id: 'cohorts.visualisation.axis.select.header' })} />
        <CohortAxisDropdownItems fields={fields} filterText={filterText} value={value} onChange={handleScroll} />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CohortAxisDropdown;
